import { render, staticRenderFns } from "./label.vue?vue&type=template&id=2a2703a1&scoped=true&lang=pug"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=2a2703a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2703a1",
  null
  
)

export default component.exports